import { X, Shield } from "lucide-react";
import type { Session } from "@supabase/supabase-js";

type TFunc = (key: string) => string;

export function AdminPanel({ open, onClose, dir }: {
  open: boolean;
  session: Session | null;
  onClose: () => void;
  t: TFunc;
  dir: "rtl" | "ltr";
}) {
  if (!open) return null;
  const isAr = dir === "rtl";

  return (
    <div dir={dir} className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose}>
      <div className="w-full max-w-md bg-white dark:bg-slate-900 rounded-3xl shadow-2xl overflow-hidden" onClick={e => e.stopPropagation()}>
        <div className="bg-gradient-to-br from-[#0A2240] to-[#0E3360] px-5 py-5 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Shield className="w-5 h-5 text-[#F5D98A]" />
            <h2 className="text-white font-bold text-lg">{isAr ? "لوحة الإدارة" : "Admin panel"}</h2>
          </div>
          <button onClick={onClose} className="w-8 h-8 rounded-full bg-white/15 hover:bg-white/25 flex items-center justify-center text-white transition-colors">
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="p-5">
          <p className="text-sm text-stone-500 dark:text-slate-400 text-center">
            {isAr ? "لا توجد إجراءات إدارية متاحة حالياً." : "No admin actions available at this time."}
          </p>
        </div>
      </div>
    </div>
  );
}
